<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 v-if="engagements.length<1">
        <v-alert :value="true" type="error">This job has 0 bids or the expert's account is expired or inactive</v-alert>
      </v-flex>

      <v-flex v-else xs12 class="list-section" v-for="bid in engagements" v-bind:key="bid._id">
        <v-layout wrap class="pa-3" v-if="bid.assigned==true">
          <v-flex xs12 md9>
            <span style="color:red;font-size: 20px">Expert Details</span>
            <div v-if="(bid.jobCount && bid.jobCount > 25) && bid.userId.rating >= 4" class="right membership">
              <span class="red--text text--darken-1">Gold</span>
              <img  src="@/assets/gold.png" alt="Gold" >
            </div>
            <div v-else-if="(bid.jobCount && bid.jobCount > 15) && bid.userId.rating >= 3" class="right membership">
              <span class="red--text text--darken-1">Silver</span>
              <img  src="@/assets/silver.png" alt="Silver" >
            </div>
            <div v-else-if="(bid.jobCount && bid.jobCount >= 7) && bid.userId.rating >= 2.5" class="right membership">
              <span class="red--text text--darken-1">Bronze</span>
              <img src="@/assets/bronze.png" alt="Bronze" >
            </div>
        </v-flex>
        <v-flex xs12 md3>
          <v-chip color="red" dark class="right">{{bid.expertPackage}}</v-chip>
        </v-flex>
          <v-flex xs12 sm2>
            <v-avatar :size="avatarSize" color="grey lighten-4">
              <img
                v-if="bid.userId.hasProfileImage==false"
                src="https://vuetifyjs.com/apple-touch-icon-180x180.png"
                alt="avatar"
              >
              <img v-else :src="`${host}/uploads/users/${bid.userId.profileImage}`" alt="avatar">
            </v-avatar>
          </v-flex>
          <v-flex xs12 sm6>
            <span>Name: {{bid.userId.firstName}} {{bid.userId.lastName}}</span>
            <br>            
            <span>Phone: <a :href="`tel:${bid.userId.countryCode}${bid.userId.phone}`"><v-icon>phone</v-icon>{{bid.userId.countryCode}}{{bid.userId.phone}}</a></span>
            <br>
            <span>Email: {{bid.userId.email}}</span>
            <br>
            <a v-if="bid.userId.countryCode" :href="`https://wa.me/${bid.userId.countryCode.replace('+','')}${bid.userId.phone}`" target="_blank">
              <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt>
            </a>
            <a v-else :href="`https://wa.me/${bid.userId.phone.replace('+','')}`" target="_blank">
              <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt>
            </a>
            <br>
          </v-flex>
          <v-flex xs12 sm4>
            <div class="text-xs-center mt-1">
              <v-rating
                v-model="rating"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                half-increments
                hover
              ></v-rating>
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            Job status: <span  style="color: green">Assigned</span>
            <v-btn
              color="green"
              flat
              class="right"
              :to="`/vip_sonko/expert/portfolio/${bid.userId._id}`"
            >View Portfolio</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- Assignment dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-toolbar color="green" flat dense dark>
          <v-toolbar-title class="title">Job Assignment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h3>Are you sure you want to assign this job to</h3>
              </v-flex>
              <v-flex xs6>
                <p
                  style="font-size:20px"
                  v-if="currentBid"
                >{{currentBid.userId.firstName}} {{currentBid.userId.lastName}} ?</p>
              </v-flex>
              <v-flex xs6>
                <v-btn class="grey darken-1" :loading="loader" dark small @click="save">Yes</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End of dialog -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EngagementsComponent",
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["webUrl"]),
    avatarSize() {
      return `80px`;
    }
  },
  props: {
    engagements: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loader: false,
      dialog: false,
      currentBid: null,
      assignedStatus: null,
      packageName: null,
      rating: 4.5
    };
  },
  methods: {
    back() {
      this.$router.push("/sonko/jobs/active");
    },
    assignJob(bid) {
      this.currentBid = bid;
      this.dialog = true;
    },
    save() {
      const data = {
        jobId: this.currentBid.jobId,
        userId: this.currentBid.userId._id
      };

      this.loader = true;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/job/assign", data })
        .then(res => {
          self.loader = false;
          self.$router.push("/vip_sonko/jobs/assigned");
        })
        .finally(() => {});
    },
    close() {
      this.dialog = false;
    },
    getSubscription(userId) {
      const self = this;
      const data = this.$store
        .dispatch("get", "/subscription/mysubscription/" + userId._id)
        .then(res => {
          self.packageName = res.subscription.packageName;
        });
      return this.packageName;
    }
  },
  created() {
    const assigned = this.$route.query.assigned;
    this.assignedStatus = assigned;
  }
};
</script>


<style scoped>
p {
  font-size: 16px;
}
.membership {
  display: flex;
}
.membership span {
  margin: auto 5px;
}
.membership img {
  width: 32px; 
  height: 40px
}
</style>
